import { TableBody, TableCell, TableRow, Typography, Paper } from "@mui/material";
import { useTranslation } from "react-i18next";

interface Props {
    searchValue: string,
    colSpan:number
}

const TableSearchNotFound = ({ searchValue,colSpan }: Props) => {
    const {t}=useTranslation("global");

    return <TableBody>
        <TableRow>
            <TableCell align="center" colSpan={colSpan} sx={{ py: 3 }}>
                <Paper
                    sx={{
                        textAlign: 'center',
                        p:3
                    }}
                >
                    <Typography variant="h6" paragraph>
                        {t("Data not found")}
                    </Typography>

                    <Typography variant="body2">
                        {t("Your search did not match any records in our database")} &nbsp;
                        <strong>&quot;{searchValue}&quot;</strong>.
                        <br /> {t("Please kindly check your search term again")}.
                    </Typography>
                </Paper>
            </TableCell>
        </TableRow>
    </TableBody>
}
export default TableSearchNotFound;